<template>
  <div class="user-center-container w">
    <!-- 左侧菜单 -->
    <el-menu
      default-active="userInfo"
      class="menu-wrapper"
      @select="handleMenuSelect"
      background-color="#f8f8f8"
      text-color="#333"
      active-text-color="#409EFF"
    >
      <el-menu-item index="userInfo">
        <span>用户信息</span>
      </el-menu-item>
      <el-menu-item index="electronicArchive">
        <span>电子档案带</span>
      </el-menu-item>
      <el-menu-item index="aiInterviewRecord">
        <span>AI面试记录</span>
      </el-menu-item>
      <!-- <el-menu-item index="changePassword">
        <span>修改密码</span>
      </el-menu-item> -->
      <el-menu-item index="testRecord">
        <span>志愿规划记录</span>
      </el-menu-item>
      <el-menu-item index="mocksRecord">
        <span>模拟填报记录</span>
      </el-menu-item>
      <!-- <el-menu-item index="classRecord">
        <span>课程预约记录</span>
      </el-menu-item> -->
      <el-menu-item index="universityCollection">
        <span>院校收藏记录</span>
      </el-menu-item>
      <el-menu-item index="userQARecord">
        <span>用户答疑记录</span>
      </el-menu-item>
    </el-menu>

    <!-- 右侧内容 -->
    <div class="content-wrapper">
      <component :is="currentComponent" />
    </div>
  </div>
</template>

<script setup>
import { shallowRef } from "vue";
import UserInfo from "@/components/UserInfo.vue"; // 引入新组件
import ChangePassword from "@/components/ChangePassword.vue";
import TestRecord from "@/components/TestRecord.vue";
import MocksRecord from "@/components/MocksRecord.vue";
import ClassRecord from "@/components/ClassRecord.vue";
import UniversityCollection from "@/components/UniversityCollection.vue";
import ElectronicArchive from "@/components/ElectronicArchive.vue";
import AIInterviewRecord from "@/components/AIInterviewRecord.vue";
import UserQARecord from "@/components/UserQARecord.vue";
// 当前显示组件
const currentComponent = shallowRef(UserInfo);

// 菜单项映射关系
const componentsMap = {
  userInfo: UserInfo,
  electronicArchive: ElectronicArchive,
  aiInterviewRecord: AIInterviewRecord,
  changePassword: ChangePassword,
  testRecord: TestRecord,
  mocksRecord: MocksRecord,
  classRecord: ClassRecord,
  universityCollection: UniversityCollection,
  userQARecord: UserQARecord,

  //   evaluationRecords: EvaluationRecords,
  //   simulationApplication: SimulationApplication,
};

// 切换组件
const handleMenuSelect = (index) => {
  currentComponent.value = componentsMap[index];
};
</script>

<style scoped>
.w {
  width: calc(100% - 20px);
  max-width: 1440px;
  margin: 0 auto;
}
.user-center-container {
  display: flex;
  min-height: calc(100vh - 60px);
  margin-top: 60px;
}

.menu-wrapper {
  width: 200px;
  padding: 20px 0;
  background-color: #f8f8f8;
  border-right: 1px solid #e4e4e4;
}

.content-wrapper {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}
</style>
